'use client';

import { createContext, useState } from "react";

const ProviderInfoContext = createContext({
    cities: [],
    providerTypes: [],
    providerTypesFiltered: [],
    viewType: "",
    setViewType: () => {}
});

export function ProviderInfoContextProvider(props) {
    const [cities, setCities] = useState(props.cities);
    const [providerTypes, setProviderTypes] = useState(props.provider_types);
    const [providerTypesFiltered, setProviderTypesFiltered] = useState(
        props.provider_types_filtered || props.provider_types
    );
    const [viewType, setViewType] = useState("list");
    
    const context = {
        cities: cities,
        providerTypes: providerTypes,
        providerTypesFiltered: providerTypesFiltered,
        viewType: viewType,
        setViewType: (view_type) => setViewType(view_type)
    }

    return <ProviderInfoContext.Provider value={context}>
        {props.children}
    </ProviderInfoContext.Provider>
}

export default ProviderInfoContext;